import React, { useRef, useEffect, useState } from 'react'
import { Title, H, Represented, StateRepresented } from '../utils.tsx';
import * as settings from '../settings.js'

export const AgeRepresentationText = ({ 
  data,
  userData
}: {
  data: Array<any>,
  userData: any
}) => {

  // Get Age Group of user
  const getAgeGroup = age => {
    if(age < 18) return '<18'
    else if(age <= 39) return '18-39'
    else if(age <= 64) return '40-64'
    else if(age <= 79) return '65-79'
    else return '>80'
  }

  const userAgeGroup = getAgeGroup(userData.age)

  // Calculate nearest Executive
  let nearestAge = 99;
  let nearestKing = null;
  let nearestKingText: any;
  if(data.hasages && userData.age >= 18)
  {
    let ageText;
    for(let e in data.executives)
    {
      if(!data.executives[e].agegroup) continue

      let m = Math.abs(userData.age - (settings.year - data.executives[e].agegroup));
      if(m < nearestAge)
      {
        nearestAge = m
        nearestKing = data.executives[e]
      }
    }

    // Year-Text
    if(!isNaN(userData.age))
    {
      const year = `Jahr${nearestAge > 1 ? 'e' : ''}`
      if((settings.year - nearestKing.agegroup) === userData.age) ageText = <>gleichalt wie Sie</>
      else if((settings.year - nearestKing.agegroup) > userData.age) ageText = <>{nearestAge} {year} älter als Sie</>
      else ageText = <>{nearestAge} {year} jünger als Sie</>
    }

    // Stitch together
    if(!data.ageperexecutive)
    {
      // No Ages per Executives
      nearestKingText = <>Der Ihnen altersmässig am nächsten stehende {settings.executive[data.type].m} <H>ist {ageText}</H>.</>
    }
    else if(nearestKing.sex === 'w')
    {
      // Female
      nearestKingText = <>Die Ihnen altersmässig am nächsten stehende {settings.executive[data.type].w}, {nearestKing.name}, <H>ist {ageText}</H>.</>
    }
    else
    {
      // Male
      nearestKingText = <>Der Ihnen altersmässig am nächsten stehende {settings.executive[data.type].m}, {nearestKing.name}, <H>ist {ageText}</H>.</>
    }
  }


  // Age Group Text
  let ageGroupText
  let representationClass;
  if(userData.age >= 18)
  {
    const e = data.agegroups[userAgeGroup].executives
    const i = data.agegroups[userAgeGroup].inhabitants
    const toleranceMin = 5
    const toleranceMax = 15

    // Get Representation Class
    if(Math.abs(e - i) <= toleranceMin) representationClass = StateRepresented.good
    else if((e - i) > toleranceMax) representationClass = StateRepresented.stronglyOver
    else if((e - i) > toleranceMin) representationClass = StateRepresented.slightlyOver
    else if((i - e) > toleranceMax) representationClass = StateRepresented.stronglyUnder
    else if((i - e) > toleranceMin) representationClass = StateRepresented.slightlyUnder

    // Gett Representation Text
    if(representationClass == StateRepresented.good) ageGroupText = 'angemessen vertreten'
    else if(representationClass == StateRepresented.stronglyOver) ageGroupText = 'stark übervertreten'
    else if(representationClass == StateRepresented.slightlyOver) ageGroupText = 'übervertreten'
    else if(representationClass == StateRepresented.stronglyUnder) ageGroupText = 'stark untervertreten'
    else if(representationClass == StateRepresented.slightlyUnder) ageGroupText = 'untervertreten'
  }

  return (
    <div className='userText'>

      <Title>Alter</Title>
      
      {userData.age >= 18 &&
        <Represented state={representationClass}/>
      }
      <p>
        
        {userData.age >= 18 &&
          <>
            Legen wir den Fokus auf Ihr Alter, <H>sind Sie im {settings.executive[data.type].noun} {ageGroupText}</H>.{' '}
            {data.hasages &&
              <>
                {nearestKingText}{' '}
              </>
            }
            Ihre Altersgruppe der <H>{settings.ageGroups[userAgeGroup]}n macht rund{' '}
            {data.agegroups[userAgeGroup].inhabitants} Prozent</H> der volljährigen Bevölkerung aus. In der Exekutive in {data.name}{' '}
            {data.agegroups[userAgeGroup].executives === 0 &&
              <H>ist niemand aus dem {settings.executive[data.type].noun} in diesem Alter.</H>
            }
            {data.agegroups[userAgeGroup].executives > 0 &&
             <>sind <H>{data.agegroups[userAgeGroup].executives} Prozent der Vertreterinnen und Vertreter</H> in diesem Alter.</>
            }

          </>
        }
      </p>

    </div>
  )
}
